module.exports = __webpack_public_path__ + "img/god-ape-quest-icon.7756e7c8.svg";